import { render } from "./ContributeChat.vue?vue&type=template&id=268ed042&scoped=true"
import script from "./ContributeChat.vue?vue&type=script&lang=js"
export * from "./ContributeChat.vue?vue&type=script&lang=js"

import "./ContributeChat.vue?vue&type=style&index=0&id=268ed042&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-268ed042"

export default script